/* eslint-disable react/display-name */
import React, { memo, Suspense, lazy } from 'react';

import { reduxConnect } from '../../common';
import { LifePageIds } from './lifePageTypes';
import { IStoreState } from '../common/interfaces/types';
import { PollenLoadingUI } from '../pollen/pollenLoadingUI';

const ColdFluPage = lazy(() => import('../coldFlu/coldFluPage'));
const OutdoorSportsPage = lazy(() => import('../outdoorSports/outdoorSportsPage'));
const SnowSkiPage = lazy(() => import('../snowSki/snowSkiPage'));
const Travel = lazy(() => import('../travel/travel'));
const ResortPage = lazy(() => import('../snowSki/resortPage'));
const PollenPage = lazy(() => import('../pollen/pollenPage'));

interface LifePageTabProps {
    activePageId: string;
}

const mapStoreStateToProps = (storeState: IStoreState) => {
    const { pageId } = storeState?.appState?.appState || {};

    return {
        activePageId: pageId
    };
};

const mapDispatchToProps = {};

export const LifePageTab = reduxConnect(mapStoreStateToProps, mapDispatchToProps)(memo(({ activePageId }: LifePageTabProps) => {

    switch (activePageId) {
        case LifePageIds.coldFlu:
        {
            return (
                <Suspense fallback={<div>Loading...</div>}>
                    <ColdFluPage />
                </Suspense>
            );
        }
        case LifePageIds.outdoorSports:
        {
            return (
                <Suspense fallback={<div>Loading...</div>}>
                    <OutdoorSportsPage />
                </Suspense>
            );
        }
        case LifePageIds.snowSki:
        {
            return (
                <Suspense fallback={<div>Loading...</div>}>
                    <SnowSkiPage />
                </Suspense>
            );
        }
        case LifePageIds.travel:
        {
            return (
                <Suspense fallback={<div>Loading...</div>}>
                    <Travel />
                </Suspense>
            );
        }
        case LifePageIds.snowSkiDetail:
        {
            return (
                <Suspense fallback={<div>Loading...</div>}>
                    <ResortPage />
                </Suspense>
            );
        }
        case LifePageIds.pollen:
        {
            return (
                <Suspense fallback={<PollenLoadingUI />}>
                    <PollenPage />
                </Suspense>
            );
        }

        default:
        {
            return (
                <Suspense fallback={<PollenLoadingUI />}>
                    {
                        // default to loading UI nothing to render
                        null
                    }
                </Suspense>
            );
        }
    }
}));

LifePageTab.displayName = 'LifePageTab';